var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOutlookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Microsoft_Outlook-Logo.wine",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 52.093,
    viewBox: "0 0 56 52.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.103,
    x2: 0.5,
    y2: -1.103,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35b8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28a8ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.174,
    y1: 1.067,
    x2: 0.826,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1784d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a63c9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14725",
    "data-name": "Path 14725",
    d: "M469.164,481.581a1.25,1.25,0,0,0-.6-1.074h-.007l-.023-.013-19.4-11.486a2.636,2.636,0,0,0-.26-.155,2.6,2.6,0,0,0-2.388,0,2.64,2.64,0,0,0-.26.155l-19.4,11.486-.023.013a1.265,1.265,0,0,0,.03,2.166l19.4,11.487a2.93,2.93,0,0,0,.26.155,2.6,2.6,0,0,0,2.388,0,2.921,2.921,0,0,0,.26-.155l19.4-11.487A1.249,1.249,0,0,0,469.164,481.581Z",
    transform: "translate(-413.164 -454.232)",
    fill: "#0a2767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14726",
    "data-name": "Path 14726",
    d: "M511.269,19.679H524V31.352H511.269ZM548.747,7.814V2.474A2.42,2.42,0,0,0,546.386,0H513.341a2.42,2.42,0,0,0-2.361,2.474v5.34l19.535,5.209Z",
    transform: "translate(-495.352)",
    fill: "#0364b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14727",
    "data-name": "Path 14727",
    d: "M511,255.5h13.023v11.721H511Z",
    transform: "translate(-495.372 -247.686)",
    fill: "#0078d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14728",
    "data-name": "Path 14728",
    d: "M949.856,255.5H936.833v11.721l13.023,11.721h11.721V267.221Z",
    transform: "translate(-908.182 -247.686)",
    fill: "#28a8ea"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14729",
    "data-name": "Path 14729",
    d: "M936.833,638.75h13.023v11.721H936.833Z",
    transform: "translate(-908.182 -619.215)",
    fill: "#0078d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14730",
    "data-name": "Path 14730",
    d: "M936.833,1022h13.023v11.721H936.833Z",
    transform: "translate(-908.182 -990.744)",
    fill: "#0364b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14731",
    "data-name": "Path 14731",
    d: "M520.453,1025.15h12.734v10.611H520.453Z",
    transform: "translate(-504.536 -993.798)",
    fill: "#14447d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14732",
    "data-name": "Path 14732",
    d: "M1362.67,1022h11.721v11.721H1362.67Z",
    transform: "translate(-1320.996 -990.744)",
    fill: "#0078d4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14733",
    "data-name": "Path 14733",
    d: "M468.213,895.27l-.025.013-19.4,10.913c-.085.052-.171.1-.26.146a2.7,2.7,0,0,1-1.052.26l-1.06-.62a2.675,2.675,0,0,1-.261-.15l-19.665-11.223h-.009l-.643-.359v22.093a2.67,2.67,0,0,0,2.687,2.651h37.645c.022,0,.042-.01.065-.01a3.3,3.3,0,0,0,.912-.19,2.642,2.642,0,0,0,.366-.19c.087-.05.237-.158.237-.158a2.629,2.629,0,0,0,1.065-2.1V894.25a1.172,1.172,0,0,1-.6,1.02Z",
    transform: "translate(-412.81 -866.901)",
    fill: "url(#linear-gradient)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14734",
    "data-name": "Path 14734",
    d: "M426.49,837.318v1.354l-20.29,13.97-21.006-14.869a.013.013,0,0,0-.013-.013l-1.927-1.159v-.977l.794-.013,1.68.964.039.013.143.091s19.743,11.265,19.8,11.291l.755.443c.065-.026.13-.052.208-.078.039-.026,19.6-11.031,19.6-11.031Z",
    transform: "translate(-371.532 -810.056)",
    fill: "#0a2767",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14735",
    "data-name": "Path 14735",
    d: "M468.214,895.27l-.025.014-19.4,10.913c-.085.052-.171.1-.26.146a2.721,2.721,0,0,1-2.388,0,2.957,2.957,0,0,1-.26-.146l-19.4-10.913-.023-.014a1.172,1.172,0,0,1-.613-1.02v22.093a2.668,2.668,0,0,0,2.685,2.651h37.606a2.668,2.668,0,0,0,2.685-2.651h0V894.25A1.172,1.172,0,0,1,468.214,895.27Z",
    transform: "translate(-412.811 -866.901)",
    fill: "#1490df"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14736",
    "data-name": "Path 14736",
    d: "M1135.612,1279.63l-.291.163a2.8,2.8,0,0,1-.26.147,2.694,2.694,0,0,1-1.024.271l7.383,8.731,12.879,3.1a2.654,2.654,0,0,0,.817-1.02Z",
    transform: "translate(-1099.355 -1240.495)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14737",
    "data-name": "Path 14737",
    d: "M1136.928,1255.44l-1.606.9a2.816,2.816,0,0,1-.26.147,2.7,2.7,0,0,1-1.024.271l3.459,9.537,16.807,2.293a2.633,2.633,0,0,0,1.052-2.1v-.285Z",
    transform: "translate(-1099.356 -1217.045)",
    opacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14738",
    "data-name": "Path 14738",
    d: "M428.556,918.994h37.566a2.7,2.7,0,0,0,1.608-.521l-21.319-12.488a2.7,2.7,0,0,1-.26-.15l-19.665-11.223h-.009l-.642-.362v22.017a2.724,2.724,0,0,0,2.722,2.727h0Z",
    transform: "translate(-412.811 -866.901)",
    fill: "#28a8ea"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14739",
    "data-name": "Path 14739",
    d: "M444.066,343.054v27.779a2.394,2.394,0,0,1-1.5,2.214,2.244,2.244,0,0,1-.886.182H425.833v-31.26h2.6v-1.3h13.245A2.392,2.392,0,0,1,444.066,343.054Z",
    transform: "translate(-412.81 -330.248)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14740",
    "data-name": "Path 14740",
    d: "M442.763,385.634v27.779a2.12,2.12,0,0,1-.2.912,2.373,2.373,0,0,1-2.188,1.481H425.833V383.247H440.38a2.186,2.186,0,0,1,1.081.273A2.368,2.368,0,0,1,442.763,385.634Z",
    transform: "translate(-412.81 -371.526)",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14741",
    "data-name": "Path 14741",
    d: "M442.763,385.634v25.174a2.4,2.4,0,0,1-2.383,2.392H425.833V383.247H440.38a2.186,2.186,0,0,1,1.081.273A2.368,2.368,0,0,1,442.763,385.634Z",
    transform: "translate(-412.81 -371.526)",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14742",
    "data-name": "Path 14742",
    d: "M441.461,385.637v25.174a2.4,2.4,0,0,1-2.383,2.392H425.833V383.25h13.245a2.385,2.385,0,0,1,2.383,2.386A.009.009,0,0,1,441.461,385.637Z",
    transform: "translate(-412.81 -371.529)",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14743",
    "data-name": "Path 14743",
    d: "M2.387,383.25H26.264a2.387,2.387,0,0,1,2.387,2.387v23.877a2.387,2.387,0,0,1-2.387,2.387H2.387A2.387,2.387,0,0,1,0,409.514V385.637A2.387,2.387,0,0,1,2.387,383.25Z",
    transform: "translate(0 -371.529)",
    fill: "url(#linear-gradient-2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14744",
    "data-name": "Path 14744",
    d: "M214.56,580.612a6.944,6.944,0,0,1,2.727-3.012,8.245,8.245,0,0,1,4.333-1.086,7.674,7.674,0,0,1,4.01,1.03,6.881,6.881,0,0,1,2.653,2.878,9.291,9.291,0,0,1,.93,4.233,9.8,9.8,0,0,1-.957,4.428,7.045,7.045,0,0,1-2.735,2.978,7.977,7.977,0,0,1-4.16,1.057,7.84,7.84,0,0,1-4.1-1.042,6.988,6.988,0,0,1-2.688-2.883,9.068,9.068,0,0,1-.94-4.182A10.07,10.07,0,0,1,214.56,580.612Zm2.907,7.072A4.507,4.507,0,0,0,219,589.665a4.007,4.007,0,0,0,2.4.721,4.2,4.2,0,0,0,2.558-.745,4.317,4.317,0,0,0,1.49-1.982,7.694,7.694,0,0,0,.475-2.765,8.417,8.417,0,0,0-.448-2.8,4.427,4.427,0,0,0-1.443-2.065,3.963,3.963,0,0,0-2.536-.781,4.136,4.136,0,0,0-2.452.728,4.545,4.545,0,0,0-1.563,2,7.944,7.944,0,0,0-.01,5.711Z",
    transform: "translate(-207.099 -558.878)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14745",
    "data-name": "Path 14745",
    d: "M1362.67,255.5h11.721v11.721H1362.67Z",
    transform: "translate(-1320.996 -247.686)",
    fill: "#50d9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOutlookLogo);
export default __webpack_public_path__ + "static/media/microsoft_outlook_logo.abd838b2e3e1b04b4d9f7d9cf63f7288.svg";
export { ForwardRef as ReactComponent };